<template>
  <div class="animated fadeIn">
    <b-card :title="'Visited Site <b>Details</b>'" sub-title="">
      <b-form-row class="form-detail">
        <b-col lg="6">
          <b-form-group
            label="Start Time"
            label-for="startTime"
            label-class="font-weight-bold"
            :horizontal="true">
            <label class="top-padding-6">{{facility.startTime}}</label>
          </b-form-group>
          <b-form-group
            label="End Time"
            label-for="endTime"
            label-class="font-weight-bold"
            :horizontal="true">
            <label class="top-padding-6">{{facility.endTime}}</label>
          </b-form-group>
          <b-form-group
            label="Site"
            label-for="site"
            label-class="font-weight-bold"
            :horizontal="true">
            <label class="top-padding-6">{{facility.site !== null && facility.site !== '' ? facility.site.name : '-'}}</label>
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group
            label="Visited By"
            label-for="visitedBy"
            label-class="font-weight-bold"
            :horizontal="true">
            <label class="top-padding-6">{{facility.visitedBy}}</label>
          </b-form-group>
          <b-form-group
            label="Description"
            label-for="description"
            label-class="font-weight-bold"
            :horizontal="true">
            <label class="top-padding-6">{{facility.description}}</label>
          </b-form-group>
        </b-col>
        <b-col md="12" class="top-padding-6">
          <b-form-group
                label="<h4><b>Photos</b></h4>"
                label-for="actions"
                style="margin: 2rem auto 1rem">
                <b-row>
                  <b-col md="12">
                    <b-form-group
                          label=""
                          label-for="photo"
                          class="top-padding-6"
                          label-class="font-weight-bold">
                      <div v-viewer>
                        <label v-if="photos.length == 0" class="text-secondary top-padding-6">&nbsp;&nbsp; No photo submitted</label>
                        <b-img
                              class="icon-large"
                              :src="p.path"
                              v-for="(p, index) in photos"
                              :key="index" />
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
          </b-form-group>
          </b-col>
      </b-form-row>
      <div slot="footer">
        <b-row>
          <b-col md="6" class="d-md-down-none">
            <b-button
                  @click="goBack()"
                  size="md"
                  variant="light"
                  class="btn-pill">
              <i class="fa fa-arrow-left"></i> Back
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'facilityCreate',
  components: {
    axios
  },
  data () {
    return {
      apiUrl: window.AppConfig.apiUrl + 'site-visit',
      apiUrlFacilityBookingStatus: window.AppConfig.apiUrl + 'facility-booking-status',
      apiUrlGetFacilityBookingStatusLog: window.AppConfig.apiUrl + 'facility-booking-status-log?ascending=1&facility_booking_uuid=',
      facility: {
        uuid: null,
        startTime: null,
        endTime: null,
        description: null,
        task: null,
        taskName: null,
        site: null,
        visitedBy: null
      },
      facilityBookingStatusLog: [],
      photos: []
    }
  },
  mounted () {
    this.getDetailInfo()
    this.getPhotos()
    // this.getFacilityBookingStatusLog()
  },
  watch: {
    '$route.params.id': function (id) {
      this.getDetailInfo()
    }
  },
  methods: {
    getDetailInfo () {
      axios.get(this.apiUrl + '/' + this.$route.params.id)
        .then(response => {
          let data = response.data
          window.setDetailValue(this.facility, response.data)
          /* if (response.data.task !== null) {
            this.getDetailTask(response.data.task)
          } */
          this.facility.startTime = data.startTime === null ? '-' : moment(response.data.startTime).format(window.AppConfig.dateFormat)
          this.facility.endTime = data.endTime === null ? '-' : moment(response.data.endTime).format(window.AppConfig.dateFormat)
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
          window.history.back()
        })
    },
    getDetailTask (taskUuid) {
      axios.get(window.AppConfig.apiUrl + 'task' + '/' + taskUuid)
        .then(response => {
          let data = response.data
          this.facility.taskName = data.name
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
          // window.history.back()
        })
    },
    getPhotos () {
      axios.get(window.AppConfig.apiUrl + 'site-visit-photo?site_visit_uuid=' + this.$route.params.id)
        .then(response => {
          this.photos = response.data._embedded.siteVisitPhoto
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
          // window.history.back()
        })
    },
    getStatusColor (value) {
      switch (value) {
        case 'Requested':
          return 'primary'
        case 'Rejected':
          return 'danger'
        case 'Approved':
          return 'success'
        case 'Check In':
          return 'info'
        case 'Check Out':
          return 'dark'
        case 'Cancelled':
          return 'warning'
        default:
          return 'light'
      }
    },

    doBookingApproval (row, status, note) {
      let self = this
      if (status === 'Rejected' && note === '') { // eslint-disable-line
        self.$alertify.error('Can\'t Update. Reject Note is Required.')
        return false
      } else {
        axios.get(self.apiUrlFacilityBookingStatus)
          .then(response => {
            if (response !== undefined) {
              let uuidStatus = null
              let datas = response.data._embedded.bookingStatus
              for (let i = 0; i < response.data.total_items; i++) {
                if (datas[i].name === status) {
                  uuidStatus = datas[i].uuid
                }
              }
              axios.patch(self.apiUrl + '/' + row.uuid,
                {
                  facilityBookingStatus: uuidStatus,
                  bookingNote: note
                }
              )
                .then(response => {
                  self.$alertify.success('Successfully updated. <br />Status: ' + '<b>' + status + '</b>')
                  row.facilityBookingStatus = status
                  this.getFacilityBookingStatusLog()
                })
                .catch(error => {
                  self.$store.dispatch('errorMessage', error)
                    .then(errMsg => {
                      self.$alertify.error(errMsg)
                    })
                })
            }
          })
          .catch(function (error) {
            self.$store.dispatch('errorMessage', error)
              .then(errMsg => {
                self.$alertify.error(errMsg)
              })
          }) // .bind(this)
      }
    },
    doConfirmRejecting (row) {
      this.$alertify.prompt('Reject Note <span style="color:red">*</span>', '',
        (evt, value) => this.doBookingApproval(row, 'Rejected', value)
      )
    },

    isRequested () {
      return this.facility.facilityBookingStatus === 'Requested'
    },

    goBack () {
      window.goBack(this)
    }
  }
}
</script>

<style>
  .icon-large {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/booking-ms/Detail.vue